import { SeoHead } from '@/components/seo-head';
import { Stack } from 'expo-router';
import React from 'react';

export default function SubscriptionLayout() {
  return (
    <>
      {/* Fluxo de assinatura: não entra em buscador nem em crawler de IA. */}
      <SeoHead noindex />
      <Stack
        screenOptions={{
          headerShown: false,
        }}
      >
        <Stack.Screen name="plans" />
        <Stack.Screen name="plan-selected" />
        <Stack.Screen name="checkout" />
        <Stack.Screen name="success" />
      </Stack>
    </>
  );
}
